import axios from "axios";
export default {
  async Login({ commit }, Form) {
    try {
      let response = await axios.post("/login", Form);
      localStorage.setItem("token", response.data.data.token)
      commit("setUser", { user: response });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  logout({ commit }) {
    commit("logout");
  },
};
